module.exports = __webpack_public_path__ + "static/media/skydive_ut.1215093c.jpg";